/* HH: view_item, add_to_cart, begin_checkout an den Tag Manager, wie src/lib/ecommerce.ts.
   item_id ist der Shopify-Handle (wie bisher). Ereignisse warten, bis der Tag Manager nach
   der Einwilligung gestartet ist; ein frueher direkter push ging im Headless-Shop verloren. */
(function () {
  var warte = [];
  function bereit() { return !!(window.google_tag_manager && window.google_tag_manager['GTM-MCB3CB8X']); }
  function abarbeiten() {
    if (!bereit()) return;
    window.dataLayer = window.dataLayer || [];
    while (warte.length) { window.dataLayer.push({ ecommerce: null }); window.dataLayer.push(warte.shift()); }
  }
  function sende(ev, ecommerce) { warte.push({ event: ev, ecommerce: ecommerce }); abarbeiten(); }
  var t = setInterval(function () { abarbeiten(); if (!warte.length && bereit()) clearInterval(t); }, 500);
  setTimeout(function () { clearInterval(t); }, 120000);
  window.hhSendeEcommerce = sende;

  var p = window.hhProdukt;
  if (p) sende('view_item', { currency: 'EUR', value: p.preis, items: [{ item_id: p.handle, item_name: p.titel, item_variant: p.variante, price: p.preis, quantity: 1 }] });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    // Formulare in der Warenkorb-Schublade (Passt dazu, Bestseller) tragen ihr Produkt selbst.
    if (f.dataset.hhHandle) {
      var preis = (parseInt(f.dataset.hhPreis, 10) || 0) / 100;
      sende('add_to_cart', { currency: 'EUR', value: preis, items: [{ item_id: f.dataset.hhHandle, item_name: f.dataset.hhTitel, price: preis, quantity: 1 }] });
      return;
    }
    if (window.hhProdukt) {
      var feld = f.querySelector('[name="quantity"]') || document.querySelector('quantity-input input');
      var q = parseInt((feld && feld.value) || '1', 10) || 1;
      var x = window.hhProdukt;
      sende('add_to_cart', { currency: 'EUR', value: x.preis * q, items: [{ item_id: x.handle, item_name: x.titel, price: x.preis, quantity: q }] });
    }
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[name="checkout"], #CartDrawer-Checkout, .cart__checkout-button');
    if (!b) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      sende('begin_checkout', {
        currency: 'EUR', value: c.total_price / 100,
        items: c.items.map(function (i) { return { item_id: i.handle, item_name: i.product_title, price: i.final_price / 100, quantity: i.quantity }; })
      });
    }).catch(function () {});
  }, true);
})();
